module.exports = __webpack_public_path__ + "static/media/Chapter 1 Slide 4.80f41c89.jpg";